import { createAction, createReducer, Dispatch } from '@reduxjs/toolkit';
import { Lead } from 'types/Apis/Lead';
import { LeadsSlice } from 'types/State';
import fetchLeadsUseCase from 'lib/UseCases/fetchLeads';

const leadsReceived = createAction<Lead[]>('leads/received');
const leadsFailed = createAction<string>('leads/fetchError');

export function fetchLeads() {
  return async function leadsFetcher(dispatch: Dispatch<any>): Promise<void> {
    try {
      const response = await fetchLeadsUseCase();
      const { user_leads: leads } = response;
      dispatch(leadsReceived(leads));
    } catch (e) {
      dispatch(leadsFailed(e.message));
    }
  };
}

const leadsReducer = createReducer<LeadsSlice>(
  {
    leads: [],
    leadsByVin: {},
  },
  {
    [leadsFailed.type]: (state, action) => {
      return {
        leads: [],
        leadsByVin: {},
        error: action.payload,
      };
    },
    [leadsReceived.type]: (state, action) => {
      return {
        leads: action.payload,
        leadsByVin: deriveLeadsByVin(action.payload),
      };
    },
  }
);

function deriveLeadsByVin(leads: Lead[]): Record<string, Lead> {
  const vins: Record<string, Lead> = {};
  leads.forEach((lead) => {
    vins[lead.vin] = lead;
  });
  return vins;
}

export function getLeadByVin(state: LeadsSlice, vin: string): Lead | undefined {
  return state.leadsByVin[vin];
}

export { leadsReceived, leadsReducer };
